<div class="p-4 md:p-6 space-y-6">
  
  <!-- FILTER SECTION (Remains same) -->
  <div class="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 mb-6">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 items-end">
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">Staff Executive</label>
        <select [(ngModel)]="filters.staffId" class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all">
          <option value="All Staff">All Staff</option>
          <option *ngFor="let s of staffDropdownList" [value]="s.id">{{ s.name }}</option>
        </select>
      </div>
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">Date From</label>
        <input type="date" [(ngModel)]="filters.dateFrom" class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all">
      </div>
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">Date To</label>
        <input type="date" [(ngModel)]="filters.dateTo" class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all">
      </div>
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">Firms/Branch</label>
        <select [(ngModel)]="filters.firmId" class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all">
          <option value="All Firms">All Firms</option>
          <option *ngFor="let f of firmList" [value]="f.id">{{ f.name }}</option>
        </select>
      </div>
      <div class="flex gap-2">
        <button (click)="clearFilters()" class="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-600 font-bold py-2.5 rounded-lg text-xs transition-all uppercase border border-gray-200">Clear</button>
        <button (click)="applyFilters()" class="flex-[2] bg-gradient-to-r from-yellow-700 to-yellow-600 hover:from-yellow-800 hover:to-yellow-700 text-white font-bold py-2.5 rounded-lg text-xs shadow-md shadow-yellow-500/20 transition-all uppercase">Apply Filters</button>
      </div>
    </div>
  </div>

  <!-- SALES EXECUTIVE PERFORMANCE TABLE -->
  <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
    <div class="p-6 flex items-center justify-between border-b border-gray-50">
      <h3 class="font-bold text-gray-800 flex items-center gap-2">
        <span class="w-2 h-6 bg-blue-500 rounded-full"></span> Sales Executive Performance
      </h3>
      <div class="flex items-center gap-4">
        <select [(ngModel)]="pageSize" (change)="applyFilters()" class="text-xs border rounded-md px-2 py-1 outline-none text-gray-500">
            <option [ngValue]="5">5 rows</option>
            <option [ngValue]="10">10 rows</option>
            <option [ngValue]="20">20 rows</option>
        </select>
        <span class="text-xs font-medium text-gray-400 uppercase tracking-widest">
            Total: {{ staffPerformance.length }}
        </span>
      </div>
    </div>

    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left">
        <thead class="text-[10px] text-gray-400 uppercase tracking-widest border-b border-gray-100">
          <tr>
            <th class="py-4 px-6">Executive Detail</th>
            <th class="py-4 px-6 text-center">Total Assigned</th>
            <th class="py-4 px-6 text-center">Sold Stock</th>
            <th class="py-4 px-6 text-center">In-Hand Stock</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-50">
          <tr *ngFor="let staff of paginatedPerformance" class="group hover:bg-blue-50/30 transition-colors">
            <td class="py-4 px-6">
              <span class="font-bold text-gray-700 block text-base">{{ staff.name }}</span>
              <span class="text-[10px] font-bold text-blue-500 uppercase">{{ staff.staffCode }}</span>
            </td>
            <td class="py-4 px-6 text-center text-gray-600 font-semibold">{{ staff.totalAssigned }}</td>
            <td class="py-4 px-6 text-center">
              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-green-50 text-green-700 border border-green-100">
                {{ staff.soldCount }} Sold
              </span>
            </td>
            <td class="py-4 px-6 text-center">
              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-yellow-50 text-yellow-700 border border-yellow-100">
                {{ staff.availableCount }} Available
              </span>
            </td>
          </tr>

          <!-- Empty State -->
          <tr *ngIf="staffPerformance.length === 0">
            <td colspan="5" class="py-20 text-center text-gray-400">No performance data found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- PAGINATION FOOTER -->
    <div *ngIf="staffPerformance.length > 0" class="px-6 py-4 bg-gray-50/50 border-t border-gray-100 flex items-center justify-between">
        <p class="text-xs text-gray-500">
            Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ currentPage * pageSize > staffPerformance.length ? staffPerformance.length : currentPage * pageSize }} of {{ staffPerformance.length }} entries
        </p>
        <div class="flex items-center gap-1">
            <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1" 
                    class="px-3 py-1 text-xs font-bold rounded border bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                Prev
            </button>
            <button *ngFor="let page of pagesArray" (click)="goToPage(page)" 
                    [class.bg-blue-600]="currentPage === page" 
                    [class.text-white]="currentPage === page"
                    [class.border-blue-600]="currentPage === page"
                    class="px-3 py-1 text-xs font-bold rounded border bg-white hover:bg-gray-50 transition-all">
                {{ page }}
            </button>
            <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages" 
                    class="px-3 py-1 text-xs font-bold rounded border bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                Next
            </button>
        </div>
    </div>
  </div>
</div>